import { render, staticRenderFns } from "./PassVerify.vue?vue&type=template&id=12f873e0"
import script from "./PassVerify.vue?vue&type=script&lang=js"
export * from "./PassVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports